// extracted by mini-css-extract-plugin
export default {"label":"ImageField_label__gVMCA","container":"ImageField_container__Du+va","photo":"ImageField_photo__9fLRf"};